import { Box, BoxProps } from '@chakra-ui/react'
import { animated } from 'react-spring'
import * as React from 'react'

import Overview from '../content/Overview'
import Page from '../page/Page'
import ScrollReveal from '../common/ScrollReveal'
import TopActivitie from './TopActivitie'
import TopArchive from './TopArchive'
import TopCovid19 from './TopCovid19'
import TopCredit from './TopCredit'
import TopMainVisual from './TopMainVisual'
import TopOutline from './TopOutline'
import usePageTransition from '../../hooks/usePageTransition'

import archive from './top_archive.json'

export type TopContentProps = BoxProps & {}

const TopContent: React.FC<TopContentProps> = ({ ...others }) => {
  const transition = usePageTransition('/')
  return (
    <>
      <Box {...others}>
        <animated.div style={transition}>
          <Page>
            <TopMainVisual />
            <Overview head1Key="top__overview__head1" head2Key="top__overview__head2" bodyKey="top__overview__body" />
            <ScrollReveal threshold="0.1">
              <TopOutline />
            </ScrollReveal>
            <ScrollReveal threshold="0.25">
              <TopCredit />
            </ScrollReveal>
            <ScrollReveal threshold="0.25">
              <TopActivitie />
            </ScrollReveal>
            <ScrollReveal threshold="0.1">
              <TopArchive products={archive} />
            </ScrollReveal>
            <ScrollReveal>
              <TopCovid19 />
            </ScrollReveal>
          </Page>
        </animated.div>
      </Box>
    </>
  )
}

export default TopContent
